import AdminCardButtons from "./AdminCardButtons"
import { formatPurchaseDate } from "../../../util/purchaseDate"

const AdminProductCard = ({
  productData,
  setUpdated,
  setCurrentProduct,
  selectedProducts,
  setSelectedProducts,
}) => {
  const product = productData

  /* ================================
     UI
  ================================= */

  return (
    <div
      className="AdminProductCard col-6 mx-auto px-4 mb-4 text-dark d-flex flex-column justify-content-center"
      style={{
        height: "18rem",
        border: "1px solid #ccc",
      }}
    >
      <div className="ProductCardInner row border h-100">
        {/* IMAGE */}
        <div
          className="d-flex justify-content-center align-items-center border p-3 bg-light"
          style={{ width: "18rem" }}
        >
          <img
            src={product.image}
            className="img-fluid"
            alt="product"
            style={{ height: "15rem" }}
          />
        </div>

        {/* CONTENT */}
        <div className="col pt-1 ps-4 d-flex flex-column justify-content-center">
          <div
            className="d-flex flex-column align-items-start justify-content-center"
            style={{ height: "80%" }}
          >
            <div className="d-flex justify-content-between align-items-center mb-2 w-100">
              <span className="badge bg-success">
                Purchase Date: {formatPurchaseDate(product.category)}
              </span>
              <div className="text-muted small fw-semibold">
                Item No: {product.item_no}
              </div>
            </div>

            {/* NAME */}
            <h5
              className="product-name fw-bold lead fs-4 mb-3 text-start"
              style={{ fontSize: "1.2rem" }}
            >
              {product.name}
            </h5>

            {/* PRICE */}
            <p className="card-price fs-6">
              <span className="fs-2 display-3">₱{product.price}</span>
            </p>
          </div>

          {/* BUTTONS */}
          <AdminCardButtons
            product={product}
            setUpdated={setUpdated}
            setCurrentProduct={setCurrentProduct}
            selectedProducts={selectedProducts}
            setSelectedProducts={setSelectedProducts}
          />
        </div>
      </div>
    </div>
  )
}

export default AdminProductCard
